export const colors = {
    white: `#ffffff`,
    bonJour: `#f1eff0`,
    pampas: `#f5f2ee`,
    carrara: `#eef0eb`,
    alto: `#d4d4d4`,
    scorpion: `#606060`,
    dustyGray: `#9b9b9b`,
    thunder: `#2a2829`,
    zigurat: `#b7cdde;`,
    turquoiseBlue: `#64d4e3`,
    turquoise: `#23ddd0`,
    screaminGreen: `#54ef93`,
    cabaret: `#dc4869`,
    roseOfSharon: `#c44601`,
    bahamaBlue: `#005e9c`,
    elephant: `#133143`,
    stratos: `#000050`,
    black: '#000000',
    camelot: `#96355d`,
    turquoiseGreenGradient: `linear-gradient(to top, #15d8e2 0%, #54ef93 100%)`,
    dandelionCrustaGradient: `linear-gradient(to top, #ffd865 0%, #fa7134 100%)`,
    mandySandybrownGradient: `linear-gradient(to top, #e0565f 0%, #f2af64 100%)`,
};
